import React from 'react'

import './messengerWelcome.css'

const PF = process.env.REACT_APP_PUBLIC_FOLDER

const MessengerWelcome = () => {
  return (
    <div className='messengerWelcome'>
        <div className="messengerWelcomeWrapper">
            <div className="messengerWelcomeIllustrationWrapper">
                <img className='messengerWelcomeIllustration' src={PF + 'person/welcome_messenger.png'} alt="" />
            </div>
            <div className='welcomeHeaderWrapper'>
                <h3 className="welcomeHeader">Welcome to Roger</h3>
            </div>
            <div className='messengerDescriptionWrapper'>
                <p className='messengerDescription'>Roger is now available in Bloom, you can now instantly and securely send and receive messages from your friends using the Roger chat services</p>
            </div>
        </div>
    </div>
  )
}

export default MessengerWelcome